import React from "react";
import {Button, Form, Input, Modal, Upload} from "antd";
import {FormModalProps} from "../../utils/useFormModal";
import Select from "../../components/Select";
import Editor from "../../components/Editor";

function ModifyModal(props: FormModalProps) {

    const {form, ...otherProps} = props

    return (
        <Modal width={900} {...otherProps}>
            <Form form={form} layout={'vertical'}>
                <Form.Item name={'classificationId'} label={'Classification'}
                           rules={[{required: true, message: 'Please select classification'}]}>
                    <Select url={'/news/classification'} textField={'name'} valueField={'id'}
                            getData={data => data.data}/>
                </Form.Item>
                <Form.Item name={'title'} label={'Title'} rules={[{required: true, message: 'Please input name'}]}>
                    <Input/>
                </Form.Item>
                <Form.Item label={'Content'} name={'contentRaw'}>
                    <Editor contentStyle={{height: 250}} uploadPrefix={'content/news'}/>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default ModifyModal;
